module.exports = __webpack_public_path__ + "img/help-evaluations.260f1ced.jpg";